import React from 'react';
import { useConfig } from '../../ConfigContext';
import { fontFamilies } from '../../../glassConsts';
import { computeOverlay, timeToPercent } from '../../../utils/overlayMath';

export default function MusicControls() {
  const { music, general, size } = useConfig();
  return (
    <>
      <div
        style={{
          paddingTop: size.height / 44,
        }}
        id="title_heart_box"
      >
        <div id="title_heart">
          <div
            style={{
              fontFamily: fontFamilies[general.font],
              fontSize: size.height / 38,
              fontWeight: 'bold',
              color: general.color,
              textAlign: 'left',
              textShadow: '0 2px 8px rgba(0,0,0,0.15)',
              whiteSpace: 'normal',
            }}
          >
            {music.name.length < 1 ? 'Název' : music.name}
          </div>
          <div
            style={{
              bottom: 250,
              fontFamily: fontFamilies[general.font],
              fontSize: size.height / 50,
              color: general.color,
              opacity: 0.75,
              textAlign: 'left',
              marginTop: 0,
              wordBreak: 'word-break',
            }}
          >
            {music.interpret.length < 1 ? 'Interpret' : music.interpret}
          </div>
        </div>
        <div id="title_heart_heart">
          {general.soundLike ? (
            <svg
              fill="red"
              width={size.height / 50}
              viewBox="0 0 122.88 107.39"
              className="svg-music-size"
            >
              <path d="M60.83,17.18c8-8.35,13.62-15.57,26-17C110-2.46,131.27,21.26,119.57,44.61c-3.33,6.65-10.11,14.56-17.61,22.32-8.23,8.52-17.34,16.87-23.72,23.2l-17.4,17.26L46.46,93.55C29.16,76.89,1,55.92,0,29.94-.63,11.74,13.73.08,30.25.29c14.76.2,21,7.54,30.58,16.89Z" />
            </svg>
          ) : (
            <svg
              fill={general.color}
              width={size.height / 38}
              viewBox="0 0 122.88 109.57"
              className="svg-music-size"
            >
              <g>
                <path d="M65.46,19.57c-0.68,0.72-1.36,1.45-2.2,2.32l-2.31,2.41l-2.4-2.33c-0.71-0.69-1.43-1.4-2.13-2.09 c-7.42-7.3-13.01-12.8-24.52-12.95c-0.45-0.01-0.93,0-1.43,0.02c-6.44,0.23-12.38,2.6-16.72,6.65c-4.28,4-7.01,9.67-7.1,16.57 c-0.01,0.43,0,0.88,0.02,1.37c0.69,19.27,19.13,36.08,34.42,50.01c2.95,2.69,5.78,5.27,8.49,7.88l11.26,10.85l14.15-14.04 c2.28-2.26,4.86-4.73,7.62-7.37c4.69-4.5,9.91-9.49,14.77-14.52c3.49-3.61,6.8-7.24,9.61-10.73c2.76-3.42,5.02-6.67,6.47-9.57 c2.38-4.76,3.13-9.52,2.62-13.97c-0.5-4.39-2.23-8.49-4.82-11.99c-2.63-3.55-6.13-6.49-10.14-8.5C96.5,7.29,91.21,6.2,85.8,6.82 C76.47,7.9,71.5,13.17,65.46,19.57L65.46,19.57z M60.77,14.85C67.67,7.54,73.4,1.55,85.04,0.22c6.72-0.77,13.3,0.57,19.03,3.45 c4.95,2.48,9.27,6.1,12.51,10.47c3.27,4.42,5.46,9.61,6.1,15.19c0.65,5.66-0.29,11.69-3.3,17.69c-1.7,3.39-4.22,7.03-7.23,10.76 c-2.95,3.66-6.39,7.44-10,11.17C97.2,74.08,91.94,79.12,87.2,83.66c-2.77,2.65-5.36,5.13-7.54,7.29L63.2,107.28l-2.31,2.29 l-2.34-2.25l-13.6-13.1c-2.49-2.39-5.37-5.02-8.36-7.75C20.38,71.68,0.81,53.85,0.02,31.77C0,31.23,0,30.67,0,30.09 c0.12-8.86,3.66-16.18,9.21-21.36c5.5-5.13,12.97-8.13,21.01-8.42c0.55-0.02,1.13-0.03,1.74-0.02C46,0.48,52.42,6.63,60.77,14.85 L60.77,14.85z" />
              </g>
            </svg>
          )}
        </div>
      </div>

      <div
        className="timeline"
        style={{
          width: '100%',
          height: 10,
          marginTop: size.height / 43,
          paddingBottom: 20,
        }}
      >
        <div>
          <div
            style={{
              width: '100%',
              height: '3px',
              backgroundColor: general.color,
            }}
            id="full-timeline"
          ></div>
          <div
            style={{
              width: `${timeToPercent(music.timeStart, music.timeEnd)}%`,
              height: '6px',
              backgroundColor: general.color,
              marginTop: -5,
            }}
            id="bold-timeline"
          ></div>
          <div
            style={{
              marginLeft: `calc(${timeToPercent(music.timeStart, music.timeEnd)}% - 2px)`,
              height: 15,
              width: 15,
              borderRadius: '100%',
              backgroundColor: general.color,
              marginTop: -10,
            }}
            id="dot-timeline"
          ></div>
        </div>
        <div
          className="flex justify-between"
          style={{
            color: general.color,
            fontSize: size.height / 50,
          }}
        >
          <div>{music.timeStart}</div>
          <div>{music.timeEnd}</div>
        </div>
      </div>

      <div
        id="music-controls"
        style={{
          marginTop: window.innerWidth < 500 ? -5 : size.height / 43,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size.height / 36}
          height={size.height / 36}
          viewBox="0 0 20 20"
          className="svg-music-size"
        >
          <path
            d="M18.74414,4.1875l-2.25-2.25c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l1.00195,1.00195h-2.22363c-2.1084,0-4.00098,1.29883-4.79688,3.25195l-2.46973,4.87305c-.58887,1.44238-1.93652,2.375-3.43359,2.375h-1.79785c-.41406,0-.75.33594-.75.75s.33594.75.75.75h1.79785c2.10938,0,4.00293-1.29883,4.79688-3.25195l2.46973-4.87305c.58984-1.44238,1.9375-2.375,3.43359-2.375h2.15918l-.9375.9375c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973l2.25-2.25c.29297-.29297.29297-.76758,0-1.06055Z"
            fill={general.color}
          />
          <path
            d="M7.10254,7.38867c-.23438,0-.46484-.10938-.61133-.31348-.7041-.98633-1.81836-1.5752-2.97949-1.5752h-1.79785c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h1.79785c1.64453,0,3.21484.82324,4.2002,2.20215.24023.33789.16309.80566-.17383,1.04688-.13281.09473-.28516.13965-.43555.13965Z"
            fill={general.color}
          />
          <path
            d="M18.74414,14.73633l-2.25-2.25c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l.95312.95312h-2.17383c-1.15527,0-2.26562-.58398-2.9707-1.5625-.24121-.33398-.70898-.41211-1.04688-.16992-.33594.24219-.41211.71094-.16992,1.04688.98535,1.36816,2.55078,2.18555,4.1875,2.18555h2.20703l-.98633.98633c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973l2.25-2.25c.29297-.29297.29297-.76758,0-1.06055Z"
            fill={general.color}
          />
        </svg>
        <div>
          <svg
            width={size.height / 17}
            viewBox="0 0 48 48"
            className="svg-music-size-controls"
          >
            <polygon points="32,15 20,24 32,33" fill={general.color} />
            <rect
              x="14"
              y="15"
              width="4"
              height="18"
              rx="2"
              fill={general.color}
            />
          </svg>
          <svg
            width={size.height / 16}
            viewBox="0 0 48 48"
            className="svg-music-size-controls"
          >
            <circle
              cx="24"
              cy="24"
              r="22"
              fill="#0000"
              stroke={general.color}
            />
            <polygon points="19,15 36,24 19,33" fill={general.color} />
          </svg>

          <svg
            width={size.height / 17}
            viewBox="0 0 48 48"
            className="svg-music-size-controls"
          >
            <polygon points="16,15 28,24 16,33" fill={general.color} />
            <rect
              x="30"
              y="15"
              width="4"
              height="18"
              rx="2"
              fill={general.color}
            />
          </svg>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size.height / 28}
          viewBox="0 0 24 24"
          fill="none"
          className="svg-music-size"
          stroke={general.color}
        >
          <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
          <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
        </svg>
      </div>
    </>
  );
}
